import axios from 'axios';

const baseEndpoint = 'v1/socialnetworks';

const SocialNetwork = {
  getStatus( type ) {
    return axios
      .get( `${baseEndpoint}/${type}/status` )
  },
};

export default SocialNetwork;



// WEBPACK FOOTER //
// ./services/SocialNetwork.js